import * as React from 'react';
import { useFavoritesAssignWidget } from './useFavoritesAssignWidget';
import { FavoritesWidgetWrapper } from '../../components/FavoritesWidgetWrapper';

export function FavoritesAssignWidgetContainer() {
  const [isMounted, setIsMounted] = React.useState(false);

  React.useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) {
    return null;
  }

  return <FavoritesAssignWidget />;
}

function FavoritesAssignWidget() {
  const favoritesAssignWidget = useFavoritesAssignWidget();

  return <FavoritesWidgetWrapper>{favoritesAssignWidget}</FavoritesWidgetWrapper>;
}
